export default __webpack_public_path__ + "static/media/support_security.aaaa3581.svg";